import { cva, VariantProps } from 'class-variance-authority';
import { ComponentType, HTMLAttributes, ReactElement } from 'react';
import { cn } from '@/util/cn'
import { NexaBlack } from '@/styles/fonts'

type ComponentProps = HTMLAttributes<HTMLElement>;

type As = 'h1' | 'h2' | 'h3' | 'span' | 'p';

export const typographyVariantMap = {
    'h1': cn('text-3xl md:text-4xl'),
    'h2': cn('text-2xl md:text-[1.75rem] leading-[1.975rem]'),
    'h3': cn('text-xl md:text-2xl'),
    'text-xl': 'text-[1.375rem] leading-[1.6rem]',
    'text-lg': 'text-[1.125rem] leading-[1.35rem]',
    'text-base': 'text-base',
    'text-md': 'text-md',
    'text-sm': 'text-sm',
    'text-xs': 'text-xs',
};

const variants = cva('inline-block antialiased', {
    variants: {
        variant: typographyVariantMap,
        fontWeight: {
            normal: 'font-normal',
            medium: 'font-medium',
            bold: 'font-bold',
        },
        fontFamily: {
            inherit: '',
            nexaBlack: NexaBlack.className,
        },
    },
    defaultVariants: {
        variant: 'text-base',
        fontWeight: 'normal',
        fontFamily: 'inherit'
    },
});

type Props = ComponentProps &
    VariantProps<typeof variants> & {
    as?: As;
};

const Typography = ({ as = 'span', variant, fontWeight, fontFamily, className, ...rest }: Props): ReactElement => {
    const Component = as as unknown as ComponentType<ComponentProps>;

    return (
        <Component
            className={cn(variants({
                variant,
                fontWeight,
                fontFamily,
            }), className)}
            {...rest}
        />
    );
};

export default Typography;
